// web/src/hooks/useGlobalCommandShortcut.ts
// Listen globally for ⌘K / Ctrl+K and open the command palette modal.
import { useEffect } from "react";
import { useCommandPaletteStore } from "../stores/commandPaletteStore";
export function useGlobalCommandShortcut() {
    const openPalette = useCommandPaletteStore((s) => s.openPalette);
    const closePalette = useCommandPaletteStore((s) => s.closePalette);
    const isOpen = useCommandPaletteStore((s) => s.open);
    useEffect(() => {
        function handler(e) {
            const isMeta = e.metaKey || e.ctrlKey;
            if (isMeta && e.key.toLowerCase() === "k") {
                e.preventDefault();
                if (isOpen) {
                    closePalette();
                }
                else {
                    openPalette();
                }
            }
        }
        window.addEventListener("keydown", handler);
        return () => window.removeEventListener("keydown", handler);
    }, [openPalette, closePalette, isOpen]);
}
